// Authentication callback screen translations for all 11 supported languages

export const authCallbackTranslations = {
  pt: {
    processing: "A iniciar sessão",
    provider_google: "Autenticando com o Google",
    provider_apple: "Autenticando com a Apple",
    provider_microsoft: "Autenticando com a Microsoft",
    success: "Autenticado com sucesso!",
    redirecting: "A redirecionar...",
    error: "Erro de autenticação",
    error_message: "A redirecionar de volta ao início de sessão...",
  },
  en: {
    processing: "Signing you in",
    provider_google: "Authenticating with Google",
    provider_apple: "Authenticating with Apple",
    provider_microsoft: "Authenticating with Microsoft",
    success: "Successfully authenticated!",
    redirecting: "Redirecting...",
    error: "Authentication failed",
    error_message: "Redirecting back to sign in...",
  },
  es: {
    processing: "Iniciando sesión",
    provider_google: "Autenticando con Google",
    provider_apple: "Autenticando con Apple",
    provider_microsoft: "Autenticando con Microsoft",
    success: "¡Autenticado con éxito!",
    redirecting: "Redirigiendo...",
    error: "Error de autenticación",
    error_message: "Redirigiendo de vuelta al inicio de sesión...",
  },
  fr: {
    processing: "Connexion en cours",
    provider_google: "Authentification avec Google",
    provider_apple: "Authentification avec Apple",
    provider_microsoft: "Authentification avec Microsoft",
    success: "Authentification réussie!",
    redirecting: "Redirection...",
    error: "Échec de l'authentification",
    error_message: "Redirection vers la connexion...",
  },
  de: {
    processing: "Anmeldung läuft",
    provider_google: "Authentifizierung mit Google",
    provider_apple: "Authentifizierung mit Apple",
    provider_microsoft: "Authentifizierung mit Microsoft",
    success: "Erfolgreich authentifiziert!",
    redirecting: "Weiterleitung...",
    error: "Authentifizierung fehlgeschlagen",
    error_message: "Weiterleitung zur Anmeldung...",
  },
  it: {
    processing: "Accesso in corso",
    provider_google: "Autenticazione con Google",
    provider_apple: "Autenticazione con Apple",
    provider_microsoft: "Autenticazione con Microsoft",
    success: "Autenticato con successo!",
    redirecting: "Reindirizzamento...",
    error: "Autenticazione fallita",
    error_message: "Reindirizzamento al login...",
  },
  nl: {
    processing: "Aanmelden",
    provider_google: "Authenticatie met Google",
    provider_apple: "Authenticatie met Apple",
    provider_microsoft: "Authenticatie met Microsoft",
    success: "Succesvol geauthenticeerd!",
    redirecting: "Doorverwijzen...",
    error: "Authenticatie mislukt",
    error_message: "Doorverwijzen naar inloggen...",
  },
  da: {
    processing: "Logger ind",
    provider_google: "Godkender med Google",
    provider_apple: "Godkender med Apple",
    provider_microsoft: "Godkender med Microsoft",
    success: "Godkendt!",
    redirecting: "Omdirigerer...",
    error: "Godkendelse mislykkedes",
    error_message: "Omdirigerer tilbage til login...",
  },
  sv: {
    processing: "Loggar in",
    provider_google: "Autentiserar med Google",
    provider_apple: "Autentiserar med Apple",
    provider_microsoft: "Autentiserar med Microsoft",
    success: "Autentiserad!",
    redirecting: "Omdirigerar...",
    error: "Autentisering misslyckades",
    error_message: "Omdirigerar tillbaka till inloggning...",
  },
  fi: {
    processing: "Kirjaudutaan sisään",
    provider_google: "Todennetaan Googlella",
    provider_apple: "Todennetaan Applella",
    provider_microsoft: "Todennetaan Microsoftilla",
    success: "Todennettu onnistuneesti!",
    redirecting: "Ohjataan...",
    error: "Todennus epäonnistui",
    error_message: "Ohjataan takaisin kirjautumiseen...",
  },
  et: {
    processing: "Sisselogimine",
    provider_google: "Autentimine Google'iga",
    provider_apple: "Autentimine Apple'iga",
    provider_microsoft: "Autentimine Microsoftiga",
    success: "Edukalt autenditud!",
    redirecting: "Suunamine...",
    error: "Autentimine ebaõnnestus",
    error_message: "Suunamine tagasi sisselogimisse...",
  }
};
